export const iconFontAwesomeLogisticsGears = (
	<i className="fa-solid fa-gears"></i>
);
